export default "__VITE_ASSET__rulYA4LN__"